import { ConfigInterface } from 'swr';
import { ResponsePromise } from 'ky';
import { api, useApi } from '@gik/core/api';
import { Organizer, InkindOrganizerSettings, OrganizerInvitation } from '@gik/core/models/gik/InkindPage';

const PATH = 'inkinds';

export async function inviteUserAsPageOrganizer(routeId: string, invitation: OrganizerInvitation): Promise<void> {
  const url = `${PATH}/${routeId}/organizers`;
  await api.post(url, { json: invitation }).json();
}

export async function cancelOrganizerInvitation(routeId: string, emailAddress: string): Promise<void> {
  const url = `${PATH}/${routeId}/invitees`;
  await api.delete(url, { json: { emailAddress } }).json();
}

export async function setOrganizerSettings(
  routeId: string,
  userId: string,
  settings: InkindOrganizerSettings
): Promise<void> {
  const url = `${PATH}/${routeId}/organizers/${userId}`;
  await api.put(url, { json: settings }).json();
}

export async function setOwnerSettings(routeId: string, settings: InkindOrganizerSettings): Promise<void> {
  const url = `${PATH}/${routeId}/owner`;
  await api.put(url, { json: settings }).json();
}

export async function removePageOrganizer(routeId: string, userId: string): Promise<void> {
  const url = `${PATH}/${routeId}/organizers/${userId}`;
  await api.delete(url).json();
}

export function getPagePendingInvitees(inkindRouteId: string): ResponsePromise {
  return api.get(`${PATH}/${inkindRouteId}/pendingInvitations`);
}

export function usePagePendingInvitees(inkindRouteId?: string, config?: ConfigInterface) {
  return useApi<Organizer[]>(inkindRouteId ? `${PATH}/${inkindRouteId}/pendingInvitations` : null, config);
}
